import type { TFunction } from '@wix/wix-i18n-config';
import type { Plan } from '../../../exported-components/pricing-plans-section';
import type { PriceData } from '../plan-box';
import { getDecodedSign } from '@wix/app-market-services';
import type { PlanPrice } from '@wix/app-market-services';

const getPriceByPeriod = ({
  plan,
  toggleValue,
  yearlyTitle,
}: {
  plan: Plan;
  toggleValue: string | null;
  yearlyTitle: string;
}): PlanPrice | undefined => {
  const hasMeterdBilling = !!plan.meterdBilling;
  return hasMeterdBilling
    ? {
        price: plan.meterdBilling?.baseFee,
        discountPrice: plan.meterdBilling?.discountBaseFee,
      }
    : toggleValue === yearlyTitle
    ? {
        price: plan.yearlyPrice?.price,
        discountPrice: plan.yearlyPrice?.discountPrice,
      }
    : {
        price: plan.monthlyPrice?.price,
        discountPrice: plan.monthlyPrice?.discountPrice,
      };
};

const getPriceTitle = ({
  isFreePlan,
  planPriceTitle,
  isMeterdBilling,
  t,
}: {
  isFreePlan: boolean;
  planPriceTitle?: string;
  isMeterdBilling: boolean;
  t: TFunction;
}) => {
  let priceTitle;
  if (planPriceTitle) {
    priceTitle = planPriceTitle;
  } else if (isFreePlan) {
    priceTitle = getFreePriceTitle({ t, isMeterdBilling });
  }
  return priceTitle;
};

const getFreePriceTitle = ({
  t,
  isMeterdBilling,
}: {
  isMeterdBilling: boolean;
  t: TFunction;
}) => {
  return isMeterdBilling
    ? t('solution.page.metered.billing.freePlanTitle')
    : t('solution.page.freePlanTitle');
};

export const parsePricePlansData = ({
  plan,
  toggleValue,
  yearlyTitle,
  symbol,
  t,
}: {
  plan: Plan;
  toggleValue: string | null;
  yearlyTitle: string;
  symbol: string;
  t: TFunction;
}): {
  priceTitle: string | undefined;
  priceSubTitle: string | undefined;
  priceData: PriceData | undefined;
} => {
  const planPrices = getPriceByPeriod({ plan, toggleValue, yearlyTitle });
  const priceTitle = getPriceTitle({
    isFreePlan: plan.isFree || Number(plan.meterdBilling?.baseFee) === 0,
    planPriceTitle: plan.title,
    isMeterdBilling: !!plan.meterdBilling,
    t,
  });

  return {
    priceTitle,
    priceSubTitle: plan.meterdBilling?.outline,
    priceData: planPrices
      ? {
          decodedSign: getDecodedSign(symbol),
          price: planPrices.price!,
          discountPrice: planPrices.discountPrice,
        }
      : undefined,
  };
};
